module.exports = __webpack_public_path__ + "static/media/super-user.c9f3e125.svg";